var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVision = function SvgVision(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.036 7.776a.424.424 0 0 0 0 .449c2.608 4.189 7.108 6.69 12.036 6.69s9.427-2.502 12.036-6.69a.424.424 0 0 0 0-.45l-.185-.297v.009A14.093 14.093 0 0 0 12 1.086c-4.928 0-9.428 2.501-12.036 6.69Zm0 0 .085.053-.085-.053ZM12 14.066A13.25 13.25 0 0 1 .827 8.002 13.249 13.249 0 0 1 12 1.935c4.544 0 8.7 2.262 11.172 6.066A13.249 13.249 0 0 1 12 14.067Zm0-11.502A5.443 5.443 0 0 0 6.563 8 5.443 5.443 0 0 0 12 13.438 5.443 5.443 0 0 0 17.437 8 5.443 5.443 0 0 0 12 2.564Zm0 10.025A4.593 4.593 0 0 1 7.412 8 4.594 4.594 0 0 1 12 3.413 4.594 4.594 0 0 1 16.588 8 4.594 4.594 0 0 1 12 12.589Zm0-6.651a.424.424 0 1 0 0-.848A2.914 2.914 0 0 0 9.09 8a.424.424 0 1 0 .847 0c0-1.137.926-2.062 2.063-2.062Z",
    fill: "#102B3F",
    stroke: "#102B3F",
    strokeWidth: 0.2
  })));
};

export default SvgVision;